import {h, Fragment} from "preact"
import { useEffect, useRef } from "preact/hooks"

export default function Carousel({ wrapperUniqueClass, carouselClass, options, init, children }) {
    const carouselRef = useRef(null);

    useEffect(() => {
        if(!window.Swiper || !children?.length > 1 || !carouselRef.current || !init) return;
        
        if(carouselRef.current.swiper) {
            carouselRef.current.swiper.destroy(true, true);
            carouselRef.current.swiper = null;
        }
        
        if(options.navigation?.nextEl && options.navigation?.prevEl) {
            options.navigation.prevEl = `.${wrapperUniqueClass} .swiper-button-prev`;
            options.navigation.nextEl = `.${wrapperUniqueClass} .swiper-button-next`;
        }
        if(options.pagination?.el) {
            options.pagination.el = `.${wrapperUniqueClass} .swiper-pagination`;
        }
        const instance = new Swiper(carouselRef.current, options);
        carouselRef.current.swiper = instance;

        return () => {
            if(carouselRef.current?.swiper) {
                carouselRef.current.swiper.destroy(true, true);
                carouselRef.current.swiper = null;
            };
        };
    }, [ children ])

    return (
        <div className={`${wrapperUniqueClass ? wrapperUniqueClass : ''} ${carouselClass ? carouselClass : ''} flex`}>
            {(init && options.navigation) && (
                <button type="button" className="swiper-button swiper-button-prev w-7 h-8 items-center justify-center flex">
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" class="transition-transform" fill="none">
                        <path class="nosto-svg-path" stroke="#2D2926" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="16" d="M5 9.495l-4-4 4-4"></path>
                    </svg>
                </button>
            )}
            <div
                className="swiper w-full flex flex-nowrap"
                ref={carouselRef}
            >
                <div className={`swiper-wrapper ${!init ? "justify-center" : ""}`}>
                    {children}
                </div>
                {(init && options.pagination) && (
                    <div className="swiper-pagination absolute bottom-0 left-0 right-0 flex w-full h-0.5 z-1"></div>
                )}
            </div>
            {(init && options.navigation) && (
                <button type="button" className="swiper-button swiper-button-next w-7 h-8 items-center justify-center flex">
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" class="transition-transform rotate-180 origin-center" fill="none">
                        <path class="nosto-svg-path" stroke="#2D2926" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="16" d="M5 9.495l-4-4 4-4"></path>
                    </svg>
                </button>
            )}
        </div>
    )
}
